const KEY = 'sgflow-pending-action'

export function setPendingAction(action: string) {
  sessionStorage.setItem(KEY, action)
}

export function consumePendingAction(action: string) {
  const pending = sessionStorage.getItem(KEY)
  if (pending !== action) return false
  sessionStorage.removeItem(KEY)
  return true
}
